<template>
  <div class="booked-bags">
    <div
      v-for="(traveler, traveler_index) in Object.keys(flexible_bags)"
      :key="`${_uid}:additional-bags:${traveler_index}`"
      :set="(traveler_detail = travelers[traveler_index])"
      class="booked-bags__item"
    >
      <div
        v-if="
          has_chargeable_bags(
            flight_offer,
            flight_offer.travelerPricings[traveler_index].travelerId,
          )
        "
      >
        {{ traveler_detail.name.firstName }}
        {{ traveler_detail.name.lastName }}
        <div
          v-for="(itinerary, itinerary_index) in Object.keys(
            flexible_bags[traveler],
          )"
          :key="`${_uid}:additional-bags:${traveler_index}:${itinerary_index}`"
          :set="(itd = flight_offer.itineraries[itinerary_index])"
        >
          <div
            v-for="(bag, bag_index) in Object.keys(
              flexible_bags[traveler][itinerary],
            )"
            :key="`${_uid}:additional-bags:${traveler_index}:${itinerary_index}:${bag_index}`"
          >
            <div
              v-if="flexible_bags[traveler][itinerary][bag].added"
              :set="(bag = flexible_bags[traveler][itinerary][bag].bag)"
            >
              <div class="ml-2">
                <span class="semibold">
                  {{ bag.quantity }}
                  {{ bag.quantity > 1 ? "bagagli" : "bagaglio" }}
                </span>
                <i>
                  ({{ itd.segments[0].departure.iataCode }}
                  {{ locations[itd.segments[0].departure.iataCode].name }}
                  -
                  {{ itd.segments[itd.segments.length - 1].arrival.iataCode }}
                  {{
                    locations[
                      itd.segments[itd.segments.length - 1].arrival.iataCode
                    ].name
                  }})
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { has_chargeable_bags } from "@liveflight/utilities/flight-offer";
export default {
  name: "booked-bags",
  props: {
    flight_offer: {
      type: Object,
      required: true,
    },
    travelers: {
      type: Array,
      default: () => [],
    },
    flexible_bags: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    locations() {
      try {
        return this.$store.state.liveflight.results.dictionaries.locations;
      } catch (e) {
        this.log("booked-bags.locations");
        this.log(e);
        return {};
      }
    },
  },
  methods: {
    has_chargeable_bags,
  },
};
</script>

<style lang="scss" scoped>
.booked-bags {
  display: flex;
  flex-direction: column;

  &__item:not(:first-child) {
    border-top: 1px solid $light-gray;
    margin-top: $grid-gutter-width / 6;
    padding-top: $grid-gutter-width / 6;
  }
}
</style>
